



















import { Component, Vue } from 'vue-property-decorator';

@Component({
  i18n: {
    messages: {
      en: {
        guidelines: 'View the guidelines for the a-melding {0}, if you did not find an answer to your question you can contact Skatteetaten as described {1}',
        contactLink: 'https://www.skatteetaten.no/en/contact/',
        guidelineLink: 'https://www.skatteetaten.no/en/business-and-organisation/employer/the-a-melding/the-a-melding-guide/',
      },
      nb: {
        guidelines: 'Du finner veiledning til a-meldingen {0}, hvis du ikke fant et svar på det du lurte på kan du kontakte Skattetaten som forklart {1}',
        contactLink: 'https://www.skatteetaten.no/kontakt/',
        guidelineLink: 'https://www.skatteetaten.no/bedrift-og-organisasjon/arbeidsgiver/a-meldingen/veiledning/',
      },
    },
  },
})
export default class AmeldingContact extends Vue {}
